import {Component, EventEmitter, Output, ViewChild} from '@angular/core';

import {CaseCreditor} from '../case-creditor';
import {CaseCreditorService} from '../case-creditor.service';

@Component({
  selector: 'app-case-creditor-edit',
  templateUrl: 'edit.component.html',
})
export class CaseCreditorEditComponent {
  @ViewChild('staticModal') staticModal;

  @Output() completed = new EventEmitter<boolean>();

  public disabled: boolean = false;

  public model: CaseCreditor;

  private givenCaseId: string;

  constructor(private readonly caseCreditorService: CaseCreditorService) {}

  public get caseId(): string {
    return this.givenCaseId;
  }

  public open(caseId: string, model: CaseCreditor): void {
    this.givenCaseId = caseId;
    this.model = model;
    this.staticModal.show();
  }

  public close() {
    this.workCompleted();
  }

  public confirmEdit($event) {
    $event.preventDefault();
    this.disabled = true;
    this.caseCreditorService
      .updateCaseCreditor(this.model.id, this.model, {
        parameters: { id: this.caseId },
      })
      .subscribe(() => {
        this.workCompleted();
      });
  }

  private workCompleted() {
    this.model = undefined;
    this.disabled = false;
    this.staticModal.hide();
    this.completed.next(true);
  }
}
